import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 68px 1fr;
  border-top: 1px solid #ccc;
  padding: 32px 8px;
`;

export const StepCounter = styled.div<{ completed?: boolean }>`
  border-radius: 100%;
  border: 2px solid ${({ completed }) => (completed ? "#10B981" : "rgba(51, 51, 51, 0.3)")};
  font-size: 20px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ completed }) => (completed ? "#FFFFFF" : "#333")};
  background-color: ${({ completed }) => (completed ? "#10B981" : "#FFFFFF")};
`;

export const BlockContent = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;
